import React from 'react';
import { motion } from 'framer-motion';
export function MakeupServices() {
  const customEase = [0.16, 1, 0.3, 1];
  const services = [{
    title: 'Bridal',
    description: 'Flawless, timeless makeup for your wedding day. Trial included. Available across all three cities.',
    image: 'https://images.unsplash.com/photo-1457972729786-0411a3b2b626?w=200&q=80'
  }, {
    title: 'Formal & Events',
    description: 'Polished makeup for special occasions and formal events. Same-day booking available for last-minute events.',
    image: 'https://images.unsplash.com/photo-1503236823255-94609f598e71?w=200&q=80'
  }, {
    title: 'Editorial & Photoshoot',
    description: 'Professional makeup artistry for editorial and creative shoots. Studio or on-location. Collaborative creative direction.',
    image: 'https://images.unsplash.com/photo-1526045478516-99145907023c?w=200&q=80'
  }, {
    title: 'Special Occasions',
    description: "Expert makeup for life's important moments. From birthdays to graduations. Tailored to you.",
    image: 'https://images.unsplash.com/photo-1519699047748-de8e457a634e?w=200&q=80'
  }];
  return <section id="services" className="py-24 md:py-32 lg:py-40 bg-espresso text-parchment overflow-hidden" data-id="element-279">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12" data-id="element-280">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        ease: customEase
      }} className="text-center mb-20" data-id="element-281">
          <h2 className="font-serif text-6xl md:text-8xl font-light mb-6" data-id="element-282">
            Makeup Services
          </h2>
          <p className="font-sans text-copper-light text-lg tracking-wide" data-id="element-283">
            Professional artistry for life's important moments.
          </p>
        </motion.div>

        {/* Horizontal Scroll on Mobile, Grid on Desktop */}
        <div className="flex overflow-x-auto lg:grid lg:grid-cols-4 gap-8 lg:gap-12 pb-10 lg:pb-0 hide-scrollbar snap-x snap-mandatory" data-id="element-284">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: index * 0.1,
          ease: customEase
        }} className="min-w-[280px] lg:min-w-0 flex-shrink-0 snap-start border-t border-copper/30 pt-8" data-id="element-285">
              <img src={service.image} alt={service.title} className="rounded-full w-20 h-20 object-cover mb-6 mx-auto lg:mx-0 border border-copper/20 img-editorial" data-id="element-286" />
              <h3 className="font-serif text-3xl font-medium mb-4 text-parchment text-center lg:text-left" data-id="element-287">
                {service.title}
              </h3>
              <p className="font-sans text-stone text-sm leading-relaxed text-center lg:text-left" data-id="element-288">
                {service.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="text-center mt-16" data-id="element-289">
          <a href="#contact-form" className="group inline-flex items-center gap-3 font-sans text-xs uppercase tracking-[0.2em] text-copper hover:text-copper-light transition-colors duration-300" data-id="element-290">
            Enquire About Services
            <span className="transform transition-transform duration-300 group-hover:translate-x-2" data-id="element-291">
              →
            </span>
          </a>
        </motion.div>
      </div>
    </section>;
}